import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export function createCustomInputControlValueAccessor(extendedInputComponent: any) {
  return {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => extendedInputComponent),
    multi: true,
  };
};
@Component({
  selector: 'hb-rich-text',
  templateUrl: './rich-text.component.html',
  styleUrls: ['./rich-text.component.scss'],
  providers: [createCustomInputControlValueAccessor(RichTextComponent)],
})
export class RichTextComponent implements ControlValueAccessor {
  @Input() model: string;
  @Input() editable: boolean;
  @Input() enableAllFormattingTools: boolean;
  @Input() placeholder: string;

  private onChangeCallback: any;

  public writeValue(value: any): void {
    if (value !== this.model) {
      this.model = value;
    }
  }

  public registerOnChange(callBackFunction: any): void {
    this.onChangeCallback = callBackFunction;
  }

  public registerOnTouched(): void {}

  public setDisabledState?(isDisabled: boolean): void {
    this.editable = !isDisabled;
  }

  public onChange() {
    // update the form
    this.onChangeCallback(this.model);
  }
}
